// extracted by mini-css-extract-plugin
export default {"container":"PurchaseCancel_container__naZgg","button":"PurchaseCancel_button__0rfXT"};